import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

const getSourceColor = (sourceName) => {
  const colors = {
    Admob: 'bg-blue-500 hover:bg-blue-600',
    Meta: 'bg-purple-500 hover:bg-purple-600',
    Unity: 'bg-green-500 hover:bg-green-600',
    AppLovin: 'bg-orange-500 hover:bg-orange-600',
    IronSource: 'bg-red-500 hover:bg-red-600',
    Vungle: 'bg-pink-500 hover:bg-pink-600',
  }
  return colors[sourceName] || 'bg-gray-500 hover:bg-gray-600'
}

/**
 * PAM 编辑面板
 * 全屏模态窗口用于编辑多个中介组
 */
function PamEditPanel({
  isOpen,
  editingGroups,
  onClose,
  onEditWaterfall,
  onRemoveGroup,
  onSubmit,
}) {
  if (!isOpen) return null

  const hasPendingChanges = editingGroups.some((g) => g.draft !== null)

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full h-full flex flex-col">
        {/* Header */}
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-2xl font-bold">编辑中介组</h2>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="h-6 w-6" />
          </Button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6">
          {editingGroups.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              未选择要编辑的中介组
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border p-3 text-left font-semibold">名称</th>
                    <th className="border p-3 text-left font-semibold">类型</th>
                    <th className="border p-3 text-left font-semibold">
                      Waterfall 价格
                    </th>
                    <th className="border p-3 text-left font-semibold w-[200px]">
                      操作
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {editingGroups.map((group) => {
                    const displayWaterfall = group.draft || group.waterfall
                    const isModified = group.draft !== null

                    return (
                      <tr
                        key={group.id}
                        className={isModified ? 'bg-yellow-50' : ''}
                      >
                        <td className="border p-3 font-medium">{group.name}</td>
                        <td className="border p-3">
                          <Badge variant="outline">{group.type}</Badge>
                        </td>
                        <td className="border p-3">
                          <div className="flex flex-wrap gap-1">
                            {displayWaterfall.map((item, index) => (
                              <Badge
                                key={`${item.id || index}-${item.name}-${item.price}`}
                                className={`${getSourceColor(item.name)} text-white`}
                              >
                                {item.name}-${item.price}
                              </Badge>
                            ))}
                          </div>
                        </td>
                        <td className="border p-3">
                          <div className="flex gap-2">
                            <Button
                              size="sm"
                              variant="default"
                              onClick={() => onEditWaterfall(group)}
                            >
                              编辑
                            </Button>
                            {isModified && (
                              <Button
                                size="sm"
                                variant="outline"
                                onClick={() => onRemoveGroup(group.id, true)}
                              >
                                重置
                              </Button>
                            )}
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={() => onRemoveGroup(group.id, false)}
                            >
                              移除
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t flex justify-end">
          <Button
            variant="default"
            size="lg"
            onClick={onSubmit}
            disabled={!hasPendingChanges}
          >
            提交更改
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PamEditPanel

